<script>
  import MenuItemsSelect from './MenuItemsSelect.svelte';
  export let originalMenuItems;  
  export let prefix = '';
</script>
{#each originalMenuItems as item} 
  <option value="{item.id}">{prefix} {item.name}</option>
  {#if item.children && item.children.length}
  <MenuItemsSelect originalMenuItems={item.children} prefix={prefix+'-'}/>
  {/if}
{/each}